<template>
  <div id="sidebar-item-container">
    <div class="product">
      <div class="product__title mb-9">
        <transition name="fade">
          <span v-show="!isSidebarMini"> FAST INTELLIGENGE </span>
        </transition>
      </div>
      <div v-if="!isSidebarMini">
        <div
          v-if="!isAlertPage"
          class="product__add-brand"
          @click="openAddBrandModal(true)"
        >
          <DsIcon
            name="add"
            size="small"
          />
          Criar painel
        </div>

        <div
          v-if="!isAlertPage"
          class="product__brands"
        >
          <span
            v-for="brand in userBrandsList"
            :key="brand"
            :class="selectedBrand.name === brand ? 'product__brands--selected': ''"
            @click="setSelectedBrand(brand)"
          >
            {{ brand }}
          </span>
        </div>
        <div class="product__divider" />
        <div class="product__exit">
          <DsIcon
            name="back"
            size="small"
          />
          <div
            class="product__exit-text"
            @click="redirectExit"
          >
            Voltar para
            <p>{{ sidebarLink.label }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DsIcon } from '@ds/icons';
import SidebarItems from '@/mixins/sidebar-items.mixin';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'SidebarItemList',
  components: {
    DsIcon,
  },
  mixins: [SidebarItems],
  props: {
    isSidebarMini: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('fastIntelligence', ['isAlertPage']),
    ...mapState('fastIntelligence', [
      'sidebarLink',
      'userBrandsList',
      'selectedBrand',
    ]),
  },
  methods: {
    ...mapActions('fastIntelligence', [
      'redirectExit',
      'openAddBrandModal',
      'setSelectedBrand',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  * {
    font-size: 14px;
    text-align: left;
    line-height: 20px;
    color: var(--white);
  }

  div {
    margin: 0;
    padding: 0;
  }

  .product {
    &__title {
      height: 19px;
      margin-left: 8px;

      span {
        width: 115px;
        height: 17px;
        text-transform: uppercase;
        font-size: var(--ds-font-size-xs);
        color: var(--default-green-color);
        font-weight: var(--ds-font-weight-semibold);
      }
    }

    &__add-brand {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 18px;
      cursor: pointer;
      margin-bottom: 20px;

      .ds-icon {
        margin-right: 12px;
      }
    }

    &__brands {
      max-height: 550px;
      overflow-y: auto;
      overflow-x: hidden;
      position: relative;

      span {
        display: flex;
        width: 193px;
        height: 48px;
        cursor: pointer;
        padding-left: 15px;
        align-items: center;
      }

      &--selected {
        background: #1f1f1f;
        border-radius: 4px;
      }
    }

    &__divider {
      width: 100%;
      opacity: 0.32;
      border-top: 1px solid var(--ds-color-silver);
      margin-top: 28px;
    }

    &__exit {
      display: flex;
      cursor: pointer;
      margin-top: 16px;

      .ds-icon {
        margin-top: 10px;
      }

      &-text {
        font-size: 10px;
        font-weight: bold;
        margin-left: 15px;
        text-transform: uppercase;
        color: var(--ds-color-primary);

        p {
          font-size: 14px;
          font-weight: normal;
          text-transform: none;
          color: var(--ds-color-white-text);
        }
      }
    }
  }

  #sidebar-item-container {
    padding: 19px 15px;
    width: 100%;

    button {
      i {
        font-size: 18px;
        vertical-align: text-bottom;
      }
    }
  }

  .fade-leave-active {
    transition: none;
  }

  .fade-enter-active {
    transition: opacity 0.3s ease-in-out;
    transition-delay: 0.1s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
